import { useTreatment } from '@splitsoftware/splitio-react';

export const REGULA_LIVENESS_FLAG = 'ENABLE_REGULA_LIVENESS_CHECK';

const ENABLED_TREATMENT = 'on';

export enum TreatmentResult {
  LOADING = 'loading',
  ENABLED = 'enabled',
  DISABLED = 'disabled'
}

export const useIsRegulaLivenessEnabled = (): TreatmentResult => {
  const { treatment, isReady } = useTreatment({ name: REGULA_LIVENESS_FLAG });

  if (!isReady) {
    return TreatmentResult.LOADING;
  }

  return treatment === ENABLED_TREATMENT ? TreatmentResult.ENABLED : TreatmentResult.DISABLED;
};
